<template>
  <div :class="['ringkasan-card', { 'is-clickable': clickable }]" @click="handleClick">
    <div class="rc-title" style="color: #e10f28; font-size: 18px; font-weight: 700;">
      {{ title }}
    </div>

    <!-- Single Value Layout -->
    <div v-if="layout === 'single'" class="rc-content single">
      <div class="rc-main-value" style="margin-bottom: 8px;">
        <span
          class="rc-label-inline"
          style="font-size: 30px; font-weight: 600; color: #1a1a1a; margin-left: 8px;"
          v-if="rightLabel"
          >{{ rightLabel }}</span
        >
        <span class="rc-value" style="font-size: 30px; font-weight: 600; color: #1a1a1a;">{{
          leftValue
        }}</span>
        <span
          class="rc-label-inline"
          style="font-size: 30px; font-weight: 600; color: #1a1a1a; margin-left: 8px;"
          v-if="leftLabel"
          >{{ leftLabel }}</span
        >
      </div>
      <div class="rc-subtext" style="font-size: 14px; color: #1a1a1a;">
        <slot name="subtext">{{ subtext || '-' }}</slot>
      </div>
    </div>

    <!-- Dual Value Layout -->
    <div v-else-if="layout === 'dual'" class="rc-content dual">
      <div class="rc-dual-wrapper">
        <div class="rc-side left-side">
          <div
            class="rc-label"
            style="font-size: 14px; color: #1a1a1a; text-align: center; line-height: 1.2; margin-right: 12px; margin-top: 5px;"
            v-if="leftLabel"
          >
            {{ leftLabel }}
          </div>
          <div class="rc-value" style="font-size: 30px; font-weight: 600; color: #1a1a1a;">
            {{ leftValue }}
          </div>
        </div>
        <div
          class="rc-divider"
          style="width: 1px; height: 40px; background-color: #eaeaea; margin: 0 24px;"
        ></div>
        <div class="rc-side right-side">
          <div class="rc-value" style="font-size: 30px; font-weight: 600; color: #1a1a1a;">
            {{ rightValue }}
          </div>
          <div
            class="rc-label"
            style="font-size: 14px; color: #1a1a1a; text-align: center; line-height: 1.2; margin-left: 12px; margin-top: 5px;"
            v-if="rightLabel"
          >
            {{ rightLabel }}
          </div>
        </div>
      </div>
      <div
        class="rc-subtext"
        style="font-size: 14px; color: #1a1a1a; display: flex; justify-content: center; align-items: center; margin-top: 8px;"
      >
        <slot name="subtext">{{ subtext || '-' }}</slot>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'RingkasanCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    layout: {
      type: String,
      default: 'single', // 'single' or 'dual'
      validator: value => ['single', 'dual'].includes(value),
    },
    leftLabel: {
      type: String,
      default: '',
    },
    leftValue: {
      type: [String, Number],
      default: 0,
    },
    rightLabel: {
      type: String,
      default: '',
    },
    rightValue: {
      type: [String, Number],
      default: 0,
    },
    subtext: {
      type: String,
      default: '',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: '',
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const router = useRouter()

    const handleClick = () => {
      if (!props.clickable || !props.to) return

      router.push({
        path: props.to,
        query: props.query || undefined,
      })
    }

    return {
      handleClick,
    }
  },
}
</script>

<style scoped>
.ringkasan-card {
  background: white;
  border-radius: 20px;
  padding: 16px;
  text-align: center;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  display: flex !important;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  transition: all 0.2s ease;
}

.ringkasan-card.is-clickable {
  cursor: pointer;
}

.ringkasan-card.is-clickable:hover {
  background: #fef4f5;
  border: 1px solid #e10f28;
}

.rc-content.single {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.rc-dual-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.rc-side {
  display: flex;
  align-items: center;
}

@media (max-width: 576px) {
  .rc-divider {
    width: 60%;
    height: 1px;
    margin: 12px 0;
  }
}
</style>
